import { useEffect } from 'react';

interface UseBeforeUnloadOptions {
  enabled?: boolean;
  onBeforeUnload?: () => void;
}

const useBeforeUnload = ({ enabled = true, onBeforeUnload = () => {} }: UseBeforeUnloadOptions) => {
  useEffect(() => {
    const handleUnload = () => {
      onBeforeUnload();
    };

    if (!enabled) {
      window.onbeforeunload = null;
      window.removeEventListener('unload', handleUnload);
      return;
    }

    window.onbeforeunload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };

    window.addEventListener('unload', handleUnload);

    return () => {
      window.onbeforeunload = null;
      window.removeEventListener('unload', handleUnload);
    };
  }, [enabled, onBeforeUnload]);
};

export default useBeforeUnload;
